module.exports = __webpack_public_path__ + "static/media/stark_power.c0689072.png";